import { FlowSteps } from '@llura/constants';

import { useStrings } from '../../../hooks/useStrings';
import { useStepTiming } from '../../../lib/analytics';
import { IntroScreen } from '../intro-screen';
import { IntroMark } from '../intro-mark';

interface IntroPrincipleProps {
  onBack: () => void;
  onNext: () => void;
  onLogin: () => void;
}

export function IntroPrinciple({ onBack, onNext, onLogin }: IntroPrincipleProps) {
  useStepTiming(FlowSteps.IntroScreen2);
  const { strings } = useStrings();
  return (
    <IntroScreen
      step={2}
      tag={strings.intro.screen2.tag}
      title={strings.intro.screen2.title}
      italic={strings.intro.screen2.italic}
      body={strings.intro.screen2.body}
      visual={<IntroMark variant="pulse" />}
      onBack={onBack}
      onNext={onNext}
      onLogin={onLogin}
    />
  );
}
